module.exports = __webpack_public_path__ + "static/img/goods-1666.ac9947a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-1666.png
// module id = zI9B
// module chunks = 2